import React from 'react'
import { Autocomplete, Chip, TextField } from '@mui/material'
import { Tag } from '../../types'
import { tagChipSx } from './tagChipStyle'

type Props = {
  options: Tag[]
  selectedIds: number[]
  onChange: (ids: number[]) => void
}

// Multi-select tag filter: a voucher matches if it carries any of the
// selected tags (voucher-tags.md §5).
const TagFilter = ({ options, selectedIds, onChange }: Props) => {
  // Pages drop ids of deleted tags from their selection; until they do, an
  // id with no matching option is simply not shown.
  const value = selectedIds
    .map((id) => options.find((t) => t.id === id))
    .filter((t): t is Tag => !!t)

  return (
    <Autocomplete<Tag, true>
      multiple
      size="small"
      options={options}
      value={value}
      onChange={(_, tags) => onChange(tags.map((t) => t.id))}
      isOptionEqualToValue={(a, b) => a.id === b.id}
      getOptionLabel={(t) => t.name}
      renderTags={(tags, getTagProps) =>
        tags.map((t, index) => {
          const { key, ...rest } = getTagProps({ index })
          return (
            <Chip
              key={key}
              size="small"
              label={t.name}
              {...rest}
              sx={tagChipSx}
            />
          )
        })
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label="Filter by Tags"
          placeholder={value.length ? '' : 'Any tag'}
        />
      )}
    />
  )
}

export default TagFilter
